import React from 'react';
import { connect } from 'react-redux';
import Toggle from './Toggle';

const FaxStatus = ({ enabled, canChange, onSetStatus, user }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {/* <span style={{marginRight: '15px'}}>{statusText}</span> */}
      {/* {
          (user.role === "admin" || user.role === "superAdmin" || user.role === 'companyGroupAdmin') &&
          <Button disabled={canChange} outline size="sm" onClick={onSetStatus}>{actionLabel}</Button>
        } */}

      <Toggle
        value={enabled}
        onToggle={e => {
          if (
            user.role === 'admin' ||
            user.role === 'enterpriseAdmin' ||
            user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer'
          ) {
            onSetStatus(e);
          } else {
            console.log('not permitted');
          }
        }}
      />
    </div>
  );
};
const mapStateToProps = state => {
  return {
    user: state.AppState.user,
  };
};
export default connect(mapStateToProps)(FaxStatus);
